<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <TextRegular
      v-if="description.length > 0"
      :style="style.description"
    >
      {{ description }}
    </TextRegular>
    <div :style="style.row">
      <GoogleMaterialIconPrimary
        :content="'location_on'"
        :color="styleVariable.color.icon"
        :style="style.icon"
      />
      <TextMutedSecondary :truncate="true">
        {{ location.length > 0 ? location : textPlaceholder }}
      </TextMutedSecondary>
    </div>
    <div :style="style.row">
      <GoogleMaterialIconPrimary
        :content="'email'"
        :color="styleVariable.color.icon"
        :style="style.icon"
      />
      <TextMutedSecondary :truncate="true">
        {{ email.length > 0 ? email : textPlaceholder }}
      </TextMutedSecondary>
    </div>
    <div
      v-for="(link, index) in links"
      :key="index"
      :style="style.row"
    >
      <GoogleMaterialIconPrimary
        :content="'link'"
        :color="styleVariable.color.icon"
        :style="style.icon"
      />
      <LinkMutedSecondary
        :href="link.url"
        :truncate="true"
      >
        {{ link.name }}
      </LinkMutedSecondary>
    </div>
  </div>
</template>

<script>
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import LinkMutedSecondary from '@modules/v2/link/link-muted-secondary'
  import TextMutedSecondary from '@modules/v2/text/text-muted-secondary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserProfile',
    inheritAttrs: false,
    components: {
      GoogleMaterialIconPrimary,
      LinkMutedSecondary,
      TextMutedSecondary,
      TextRegular,
    },
    props: {
      tenantUser: {
        type: Object,
        required: false,
        default: () => {}
      },
    },
    data: function () {
      return {
        textPlaceholder: 'N/A',
        styleVariable: {
          color: {
            icon: 'none',
          },
        },
        style: {
          container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          },
          description: {
            margin: '0 0 12px 0',
          },
          icon: {
            margin: `0 ${Layout.space.sm} 0 0`,
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            height: '18px',
            margin: `${Layout.space.xs} 0`,
            width: '100%',
          },
        },
      };
    },
    created: function () {
      this.styleVariable.color.icon = this.color.dark3();
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      description: function () {
        const description = this.tenantUser?.description;
        return !!description && description.trim().length > 0 ? description : '';
      },
      email: function () {
        const email = this.tenantUser?.user?.email;
        return !!email && email.trim().length > 0 ? email : '';
      },
      links: function () {
        const links = this.tenantUser?.links;
        return links ? links : [];
      },
      location: function () {
        const location = this.tenantUser?.location;
        return !!location && location.trim().length > 0 ? location : '';
      },
    },
  };
</script>
